// Car and hardware documentation can be added as those projects are ready.
// Photography accepts any number of { src, alt, caption } entries.
export const photography = [
  {
    src: "/images/photography/pink-rose.webp",
    alt: "Close-up of a pink rose surrounded by green leaves",
    caption: "Pink rose",
  },
  {
    src: "/images/photography/resting-cat.webp",
    alt: "Black and white cat resting on a stone",
    caption: "Resting cat",
  },
  {
    src: "/images/photography/monkey.webp",
    alt: "Monkey sitting beside a wooded path in sunlight",
    caption: "Monkey",
  },
];
export const outsideProjects = [
  {
    id: "car",
    category: "AUTOMOTIVE",
    title: "My car",
    image: "/images/car-study.svg",
    alt: "Line drawing of a car, placeholder for project photography",
    description: "Some of the modifications I've made to my car.",
    detailsLabel: "More about the car",
    details: [["Modifications", "Photos and a list of the changes are coming soon."]],
  },
  {
    id: "hardware",
    category: "HARDWARE",
    title: "Hardware projects",
    image: "/images/hardware-study.svg",
    alt: "Illustrated circuit board placeholder",
    description: "Other things I've built outside of work.",
    detailsLabel: "More about these projects",
    details: [["Build details", "Photos and project details are coming soon."]],
  },
];
